const steps = [
  {
    icon: "ri-search-line",
    step: "STEP 01",
    title: "Understand Your Business",
    desc: "We study your processes, challenges, and goals",
  },
  {
    icon: "ri-pencil-ruler-line",
    step: "STEP 02",
    title: "Design the Solution",
    desc: "We map out a system tailored to your operations",
  },
  {
    icon: "ri-code-s-slash-line",
    step: "STEP 03",
    title: "Build & Integrate",
    desc: "We develop and connect the system to your workflow",
  },
  {
    icon: "ri-rocket-line",
    step: "STEP 04",
    title: "Deploy & Support",
    desc: "We launch, train your team, and provide ongoing support",
  },
];

export default function ApproachSection() {
  return (
    <section className="py-12 md:py-16 bg-graphite-850">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">Our Approach</h2>
          <p className="text-base text-silver-300 mb-10 max-w-2xl">
            A proven process that ensures your custom solution is built right and built to last.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((step, i) => (
              <div key={step.step} className="relative">
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-8 left-[60%] right-0 h-px bg-gradient-to-r from-emerald-accent/30 to-transparent" />
                )}
                <div className="glass-card p-6 h-full group">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-graphite-800 mb-5">
                    <i className={`${step.icon} text-xl text-emerald-accent group-hover:scale-110 transition-transform duration-300`} />
                  </div>
                  <span className="text-xs font-bold text-emerald-accent tracking-wider uppercase mb-2 block">
                    {step.step}
                  </span>
                  <h3 className="text-base font-semibold text-white mb-2 group-hover:text-emerald-soft transition-colors duration-300">{step.title}</h3>
                  <p className="text-sm text-silver-300 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}